import { __awaiter, __generator } from "tslib";
import { bundleIcon, Tag20Filled, Tag20Regular } from '@fluentui/react-icons';
import { CustomFilterType, FileFilterKey, FileFilterToIconMap, LocationFilterKey, LocationFilterToIconMap, } from '@office-start/base-edgeworth-control';
import { getBase64DataUri } from '@office-start/url-parser-utility';
import React from 'react';
import styles from '../QuickAccessControl.module.scss';
export function getCustomPivotIconElement(customPivot, fetchPictureData) {
    return __awaiter(this, void 0, void 0, function () {
        var fileFilterKey, locationFilterKey, TagIcon;
        return __generator(this, function (_a) {
            switch (customPivot.customFilterType) {
                case CustomFilterType.FileType:
                    fileFilterKey = Object.values(FileFilterKey).find(function (key) { return key === customPivot.customFilterKey; });
                    return [2 /*return*/, !!fileFilterKey
                            ? FileFilterToIconMap.get(fileFilterKey)
                            : undefined];
                case CustomFilterType.Location:
                    locationFilterKey = Object.values(LocationFilterKey).find(function (key) { return key === customPivot.customFilterKey; });
                    return [2 /*return*/, !!locationFilterKey
                            ? LocationFilterToIconMap.get(locationFilterKey)
                            : undefined];
                case CustomFilterType.SharedBy:
                case CustomFilterType.OwnedBy:
                    if (fetchPictureData) {
                        return [2 /*return*/, fetchPictureData(customPivot.customFilterKey)
                                .then(function (encodedData) {
                                if (!encodedData) {
                                    return undefined;
                                }
                                var imageUrl = getBase64DataUri('image/png', encodedData);
                                return (React.createElement("img", { className: styles['custom-pivot__img'], src: imageUrl, alt: customPivot.customFilterKey }));
                            })
                                .catch(function (_err) {
                                return undefined;
                            })];
                    }
                    return [2 /*return*/, undefined];
                case CustomFilterType.Tag:
                case CustomFilterType.Tagv2:
                    TagIcon = bundleIcon(Tag20Filled, Tag20Regular);
                    return [2 /*return*/, (React.createElement("span", null,
                            React.createElement(TagIcon, null)))];
                case CustomFilterType.Pending:
                    return [2 /*return*/, undefined];
                default:
                    return [2 /*return*/, undefined];
            }
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=getCustomPivotIconElement.js.map